import { Middleware } from "./middleware"


export default {
    getMenu(origin) {
        return new Middleware()
            .method('GET')
            .append(`/menu/${origin}`)
            .build()
    },
    uploadFileSignedUrl(file_name){
        return new Middleware()
        .method('GET')
        .append(`/upload/signedurl/${file_name}`)
        .build()
    },

    exportFileCsv(exportOrigin, filter){
        return new Middleware()
        .method('GET')
        .append(`/odin/${exportOrigin}/export`)
        .params({
            findBy: filter.search,
            page: filter.page,
            size: filter.size,
            startDate: filter.rangeDate?.start,
            endDate: filter.rangeDate?.end,
            idCompany: filter.idCompany,
            status: filter.status,
            idAnalyst: filter.idAnalyst,
            severity: filter.severity,
            criticality: filter.criticality
        })
        .responseType('blob')
        .build()
    },
    putFile(url,file){
        let formBlob = new Blob([file], {type:'aplication/octet-stream'});
        // formBlob.append('file', file);
        return new Middleware()
        .method('PUT')
        .removeHeader(true)
        .contentType('application/octet-stream')
        .append(`${url}`,'external')
        .setData(formBlob)
        .build()
    },
    getMessages(origin,id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/${origin}/${id}/messages`)
            .build()

    },
    sendMessages(origin,message, id) {
        return new Middleware()
            .method('POST')
            .append(`/odin/${origin}/${id}/messages`)
            .setData(message)
            .build()

    },
}